import { computed, ref } from 'vue'

export function useAdminBackButton() {
  const microsDatas = window.microsDatas || {}
  const {
    isLoggedInMA = false,
    isCpaasSubAccount = false,
    isExternalUserView = false
  } = microsDatas
  const isLoading = ref(false)
  const backButtonConfig = computed(() => {
    if (isLoggedInMA) {
      return {
        url: '/ma_switch_back'
      }
    }

    if (isExternalUserView) {
      return {
        url: isCpaasSubAccount
          ? '/external/account/cpaas/manage/login_back'
          : '/external/account/manage/login_back'
      }
    }

    return { url: '' }
  })

  const showBackButton = computed(() => isLoggedInMA || isExternalUserView)
  const navigateBack = (backUrl) => {
    if (backUrl) window.location.href = backUrl
  }

  async function handleBack() {
    const { url } = backButtonConfig.value
    if (!url) return
    isLoading.value = true
    await navigateBack(url)
  }

  return {
    backButtonConfig,
    showBackButton,
    isLoading,
    handleBack
  }
}
